import { render, staticRenderFns } from "./ItemsTrain.vue?vue&type=template&id=2ca2898e&scoped=true"
import script from "./ItemsTrain.vue?vue&type=script&lang=js"
export * from "./ItemsTrain.vue?vue&type=script&lang=js"
import style0 from "./ItemsTrain.vue?vue&type=style&index=0&id=2ca2898e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca2898e",
  null
  
)

export default component.exports